import gql from 'fraql'

export const REST_POINT_BY_ID = gql`
    query allRestPoints ($id: Int) {
        allRestPoints (condition: {
            id: $id
        }) {
            nodes {
                id
                address
                active
                courierAutoAssign
                location
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/constants/graphql/restpoint.js